import { COUPON_TYPE } from 'src/app/product-capture/model/enums/coupon-type.enum';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALLABILITY,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON_CONVERSION,
  PAYOFF_COUPON_FREQUENCY,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE,
  PAYOFF_PARTICIPATION_STRIKE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
  SUMMARY_FREQUENCY,
} from '../../mockups/consts/product-capture-field-selectors.consts';
import { DEFAULT_AND_HIDE_CAPITAL_BASE_VALUES } from './cln.settings';
import { PERFORMANCE_TYPE_KEYS } from 'src/app/product-capture/model/consts/performance-type.const';

export const DUAL_CURRENCY_NOTE_SETTINGS = {
  id: ProductTypeEnum.DUAL_CURRENCY_NOTE,
  label: 'Dual Currency Note',
  effects: [
    {
      formControlNames: [
        PAYOFF_PARTICIPATION_UPSIDE_TYPE,
        PAYOFF_PARTICIPATION_BASE_TYPE,
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
      ],
      selectValues: ['NONE'],
      hidden: true,
    },
    {
      formControlNames: [SUMMARY_FREQUENCY],
      selectValues: ['AT_MATURITY'],
      readOnly: true,
    },
    {
      formControlNames: [SUMMARY_SETTLEMENT_TYPE],
      selectValues: ['CASH'],
      readOnly: true,
    },
    {
      formControlNames: [SUMMARY_PERFORMANCE_TYPE],
      selectValues: [PERFORMANCE_TYPE_KEYS.SINGLE],
      readOnly: true,
    },
    {
      formControlNames: [PAYOFF_COUPON_TYPE],
      selectValues: [COUPON_TYPE.FIXED],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_FREQUENCY],
      readOnly: true,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_TYPE],
      selectValues: ['PUT'],
      options: ['PUT', 'KNOCK_IN_PUT'],
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_STRIKE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: '100%',
          indicativeValue: null,
        },
      ],
    },
    {
      formControlNames: [PAYOFF_COUPON_CONVERSION],
      selectValues: [false],
    },
    {
      formControlNames: [
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_CALLABILITY_CALLABILITY,
      ],
      hidden: true,
    },
    ...DEFAULT_AND_HIDE_CAPITAL_BASE_VALUES,
    {
      formControlNames: [
        SUMMARY_UNDERLYING_ASSETS_GROUP,
        PAYOFF_COUPON_TYPE,
        PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
        PAYOFF_COUPON_CONVERSION,
      ],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE],
      readOnly: true,
    },
  ],
};
